import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Service from './profile.service'
import './profile.styles.scss'
import Dialog from '../../../components/dialog/dialog.component'
import Loading from '../../../components/loading/loading.component'
import Form from './form.component'
import FormHelper from '../../../utils/FormHelper'

class Profile extends React.Component {

    constructor(props) {
        super(props)
        this.service = Service(this)
        this.state = this.service.getDefaultState()
    }

    componentDidMount(){
        this.service.loadProfile()
    }

    onSubmit = (e) => {
        e.preventDefault()
        this.service.isValid() && this.service.updateProfile()
    }

    onCancel = () => this.props.history.push('/settings')

    render() {
        return (
            <>
                {(this.state.updating || this.state.loadingProfile) && <Dialog><Loading></Loading></Dialog>}
                <div className="profile">
                    <div className="header">
                        <h1>My Profile</h1>
                        <br/>
                    </div>
                    <div className="card">
                        <div className={"flag " + this.state.flag.type}>
                            {this.state.flag.text}
                        </div>
                        <Form {...this.state} onChange={FormHelper(this, "profile").onChange} onSubmit={this.onSubmit} onCancel={this.onCancel}/>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
}

export default connect(mapStateToProps)(withRouter(Profile))